const r = (e) => e.replace(/<[^>]*>?/gm, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&aring;/g, "å").replace(/&Aring;/g, "Å").replace(/&ouml;/g, "ö").replace(/&Ouml;/g, "Ö").replace(/&auml;/g, "ä").replace(/&Auml;/g, "Ä").replace(/&ndash;/g, "-"), t = (e) => e.charAt(0) === e.charAt(0).toUpperCase(), a = (e) => e.length === 0 ? e : e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), p = (e) => e && e.length === 12 ? `${e.substring(0, 8)}-${e.substring(8)}` : e;
export {
  a as capitalizeFirstLetter,
  p as insertDashIntoSsn,
  t as isFirstLetterUpperCase,
  r as removeHTMLfromString
};
